import { createAsyncThunk } from '@reduxjs/toolkit';

export const setFormStateAsync = createAsyncThunk(
    'projectForm/setFormStateAsync',
    async (formState, { getState }) => {
        // console.log("🚀 ~ file: setFormStateAsync.js:18 ~ setFormStateAsync", formState)
        return { formState };
    }
);